<div appScrollspy [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)">
  <!-- Begin page -->
  <div class="layout-wrapper landing">
    <nav class="navbar navbar-expand-lg navbar-landing fixed-top" id="navbar" [ngClass]="{ 'white-background': isScrolled }">
      <div class="container">
        <a class="navbar-brand" routerLink="/" (click)="route_home()">
          <img src="assets/images/svg/figma2.png" class="card-logo card-logo-dark" alt="logo dark" height="">
          <!-- <img src="assets/images/svg/figma2.png" class="card-logo card-logo-light" alt="logo light" height=""> -->
        </a>
        <button class="navbar-toggler py-0 fs-20 text-body" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleMenu()">
          <i class="mdi mdi-menu"></i>
        </button>
        <div #navbarContent class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mx-auto mt-2 mt-lg-0" id="navbar-example">
            <div class="col">
              <div ngbDropdown class="d-inline-block  nav-link" #deviceDrop1="ngbDropdown">
                <a id="dropdownBasic2" ngbDropdownToggle style="color:black; cursor: pointer; font-weight: 500; font-size: 14px!important;" (mouseenter)="deviceDrop1.open(); openDropdownMenu('services')" id="nav4" (click)="onClick4()">
                  Services
                </a>
              </div>
            </div>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0);" (click)="onClick()" (mouseenter)="closeDropdown()">Track Orders</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0);" (click)="onClick3()" (mouseenter)="closeDropdown()">Retail Care Plans</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0);" (click)="onClick1()" (mouseenter)="closeDropdown()">Get A Demo</a>
            </li>
          </ul>
          <div class="d-flex">
            <a routerLink="/auth/login" class="btn btn-primary fw-medium text-decoration-none text-dark" style="color: white!important;background: #0b4444;border: 0b4444 0px soild;">Sign
              in</a>
          </div>
        </div>
      </div>
    </nav>
    <div style="overflow-x: hidden;">
      <div class="image2">
        <div class="container">
          <div class="row">
            <div class="col-md-5">
              <h1 class="headingText" style="margin-top: 150px;">
                <span class="blueOrgangeGradient">Buymore</span> <br>
                <span class="blueOrgangeGradient">D2C</span>
              </h1>
              <p class="header-content">
                Scale Faster, Deliver Better, Win More Customers
              </p>
              <button class="blueBtn p-2 mt-3" style="color: white;" routerLink="/contacts">Get a Demo</button>
            </div>
            <div class="col-md-7 laptop">
              <div class="d-flex justify-content-end">
                <div class="vertical-marquee-container1 me-5">
                  <div class="vertical-marquee1">
                    <img src="assets/images/svg/ready.svg" alt="Image 1" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/reddy1.svg" alt="Image 2" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/ready3.svg" alt="Image 3" class="img-fluid" height="200px" width="200px">
                    <img src="assets/images/svg/ready.svg" alt="Image 1" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/reddy1.svg" alt="Image 2" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/ready3.svg" alt="Image 3" class="img-fluid" height="200px" width="200px">
                    <img src="assets/images/svg/ready.svg" alt="Image 1" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/reddy1.svg" alt="Image 2" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/ready3.svg" alt="Image 3" class="img-fluid" height="200px" width="200px">
                  </div>
                </div>
                <div class="vertical-marquee-container">
                  <div class="vertical-marquee">
                    <img src="assets/images/svg/ready.svg" alt="Image 1" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/reddy1.svg" alt="Image 2" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/ready3.svg" alt="Image 3" class="img-fluid" height="200px" width="200px">
                    <img src="assets/images/svg/ready.svg" alt="Image 1" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/reddy1.svg" alt="Image 2" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/ready3.svg" alt="Image 3" class="img-fluid" height="200px" width="200px">
                    <img src="assets/images/svg/ready.svg" alt="Image 1" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/reddy1.svg" alt="Image 2" class="img-fluid" width="200px" height="200px">
                    <img src="assets/images/svg/ready3.svg" alt="Image 3" class="img-fluid" height="200px" width="200px">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- logo-carousel.component.html -->

      <div class="one">
        <div class="one">
          <ngb-carousel [interval]="3000" [wrap]="true" [showNavigationArrows]="false" [showNavigationIndicators]="false">
            <ng-template ngbSlide *ngFor="let group of brandImagesGrouped">
              <div class="row justify-content-center align-items-center my-auto mb-5">
                <div class="col" *ngFor="let testimonial of group">
                  <div class="d-flex justify-content-center align-items-center">
                    <img [src]="testimonial.image" alt="Logo" title="Logo" style="width: 150px; height: 60px;">
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-carousel>
        </div>
        <!-- <owl-carousel-o [options]="customOptions1">
          <ng-container *ngFor="let testimonial of brandImages">
            <ng-template carouselSlide>
              <div class="row justify-content-center align-items-center my-auto mb-5">
                <div class="col-md-2">
                  <div class="justify-content-center">
                    <div class="d-flex justify-content-center align-items-center">
                      <img [src]="testimonial.image" class="" alt="Technology" title="Technology" style="width: 150px!important; height: 60px!important;">
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o> -->
      </div>

      <div class="container one">
        <div class="row">
          <p class="small">The most trusted growth partner for leading D2C brands</p>
          <p class="text mt-2">From warehousing to last-mile delivery</p>
          <p class="text1">Powering brands to scale smarter & faster</p>
          <p class="text1">Seamless returns & smooth operations</p>

        </div>

        <div class="mobile">
          <div class="mt-4 text-center">
            <p class="content-text">12 Years+</p>
            <p class="content-text1">Years of experience</p>
          </div>
          <div class=" mt-5 text-center">
            <p class="content-text">30 Lakhs+</p>
            <p class="content-text1">Parcels delivered</p>
          </div>
          <div class=" mt-5 text-center">
            <p class="content-text">450 +</p>
            <p class="content-text1">Business partners</p>
          </div>
          <div class=" mt-5 text-center">
            <p class="content-text">12 +</p>
            <p class="content-text1">Warehouses</p>
          </div>
        </div>

        <div class="laptop">
          <div class="row col-md-12 mb-5 mt-5 one">
            <div class="col-md-6">
              <div class="mb-4">
                <div class="row">
                  <div class="col-md-6 text2">
                    <p class="content-text">13 Years+</p>
                    <p class="content-text1">Years of experience</p>
                  </div>
                  <div class="col-md-6 text2">
                    <p class="content-text">45 Lakhs+</p>
                    <p class="content-text1">Parcels delivered pm</p>
                  </div>
                </div>
              </div>
              <div class="mt-5" style="margin-top: 90px!important;">
                <div class="mt-5">
                  <div class="mb-4">
                    <div class="row">
                      <div class="col-md-6 text3">
                        <p class="content-text">500 +</p>
                        <p class="content-text1">Business partners</p>
                      </div>
                      <div class="col-md-6 text3">
                        <p class="content-text">6% Avg RTO</p>
                        <p class="content-text1">Maintained pm</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5" style="margin-top: 90px!important;">
                <div class="mt-5">
                  <div class="mb-4">
                    <div class="row d-flex justify-content-center">
                      <div class="col-md-6 text3">
                        <p class="content-text">100+</p>
                        <p class="content-text1">Sites Developed</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <img src="assets/images/svg/delever.png" class="ms-5 d-flex justify-content-end" width="500" height="250px">
            </div>
          </div>
        </div>
        <div class="demoStrip six">
          <div class="laptop">
            <div class="box d-flex justify-content-center">
              <img src="assets/images/svg/speaker.webp" height="30" width="30" class="mt-1 me-3 pt-1">
              <p class="box1 mt-1 pt-1" style="margin-bottom: 0;">Experience Our Data Driven Strategies For Growth & Efficiency.</p>
              <button class="blueBtn p-2 ms-3 mt-1">Book A Demo</button>
            </div>
          </div>
        </div>
        <div class="homeContentWrapper two">
          <p class="newSize">
            <span class="greenPurpleGradient"> The D2C Dilemma </span> <br> Overcomming fulfilment Chalanges
          </p>
        </div>

        <div class="laptop">
          <div class="row two">
            <div class="col-md-6">
              <div>
                <p [ngClass]="{'active-text': isActive1(0)}" class="slider-text" (click)="goToSlide1(0)">Fragmented Logistics</p>
                <p class="slider1">Disparate systems, lack of visibility, inefficient processes.</p>
              </div>
              <hr>
              <div>
                <p [ngClass]="{'active-text': isActive1(1)}" class="slider-text" (click)="goToSlide1(1)">High RTOs</p>
                <p class="slider1">Costly returns, impacting profitability and customer satisfaction.</p>
              </div>
              <hr>
              <div>
                <p [ngClass]="{'active-text': isActive1(2)}" class="slider-text" (click)="goToSlide1(2)">Poor Delivery TAT</p>
                <p class="slider1">Slow delivery times leading to customer churn.</p>
              </div>
              <hr>
              <div>
                <p [ngClass]="{'active-text': isActive1(3)}" class="slider-text" (click)="goToSlide1(3)">Unreliable Fulfillment</p>
                <p class="slider1">Inconsistent service levels, damaging brand reputation.</p>
              </div>
              <hr>
              <div>
                <p [ngClass]="{'active-text': isActive1(4)}" class="slider-text" (click)="goToSlide1(4)">Post-Purchase Experience</p>
                <p class="slider1">Delivery is not the end 4 it¾s the beginning of brand trust.</p>
              </div>
              <hr>
              <div>
                <p [ngClass]="{'active-text': isActive1(5)}" class="slider-text" (click)="goToSlide1(5)">Real-Time Visibility & Tracking</p>
                <p class="slider1">No single dashboard = No control</p>
              </div>
              <hr>
            </div>

            <div class="col-md-6 ige">
              <div id="imageCarousel" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item p-3 mt-3" [class.active]="currentSlide1 === 0">
                    <img src="assets/images/svg/servies/delim.jpg" class="d-block w-100" style="border-radius: 10px;height: 420px;" alt="Ship X">
                  </div>
                  <div class="carousel-item p-3 mt-3" [class.active]="currentSlide1 === 1">
                    <img src="assets/images/svg/servies/delim.jpg" class="d-block w-100" style="border-radius: 10px;height: 420px;" alt="Cargo">
                  </div>
                  <div class="carousel-item mt-3 p-3" [class.active]="currentSlide1 === 2">
                    <img src="assets/images/svg/servies/delim.jpg" class="d-block w-100" style="border-radius: 10px;height: 420px;" alt="Launch X">
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="container eight">
        <div class=" ">
          <div class="homeContentWrapper">
            <p>Single Inventory Multi channel<span class="yellowPurpelGradient light"> Integration</span></p>
            <p class="texting1">Integrete 15+ Channels In Single Dashboard</p>
          </div>
        </div>
      </div>
      <div class="container eight">
        <div class="homeContentWrapper">
          <p> <span class="blueOrgangeGradient"> What Buymore D2C </span> Can Do For You</p>
        </div>
      </div>
      <div class="container">
        <div class="d-flex justify-content-center mt-5">
          <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner text-center">
              <div class="carousel-item active">
                <p class="testi_text_info">At Buymore, we go beyond being just a fulfilment partner. We provide complete end-to-end D2C solutions—from website development and maintenance to warehousing, order processing, and last-mile delivery. Our expertise helps brands reduce costs, lower RTO rates, and achieve higher profitability while ensuring seamless customer experiences.</p>
              </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>